import { getContext } from '@fiverr-private/fiverr_context';
import { WORDS_TO_SHOW_MORE } from './constants';

/**
 * Returns ordered filtered list of notable clients
 *
 * @param {Array<object>} notableClients
 */
export const getDisplayedNotableClients = (notableClients = []) =>
    notableClients.filter(validClient)
        .sort((clientA, clientB) => clientSortPoints(clientB) - clientSortPoints(clientA));

const validClient = (client) =>
    client?.enriched_details?.name && (client?.enriched_details?.logo || client?.enriched_details?.image_name);

const clientSortPoints = (client) =>
    !!client.enriched_details.in_fortune * 1000 - client.enriched_details.name.length;

/**
 * Returns Array -
 *   First item - Does it have more text than the preview
 *   Second item - The previewed version (or full if it's short)
 *
 * @param {string} description
 * @returns {Array<boolean,string>}
 */
export const descriptionHasMore = (description) => {
    if (!description) {
        return [ false, '' ];
    }

    const descriptionWords = description.split(' ');
    const hasMore = descriptionWords.length > WORDS_TO_SHOW_MORE;
    const previewDescription = descriptionWords.slice(0, WORDS_TO_SHOW_MORE).join(' ');
    const threeDots = hasMore ? '...' : '';

    return [ hasMore, previewDescription.concat(threeDots) ];
};

export const getClientLogoPath = (client) => client.enriched_details.logo ||
    `https://fiverr-res.cloudinary.com/t_clients_thumb,q_auto,f_auto/noteable_clients/${client.enriched_details.image_name}`;

/**
 * Returns Boolean -
 *   If the Notable Clients component should be rendered
 *
 * @param {Array<object>} notableClients
 * @returns {boolean}
 */
export const shouldRenderNotableClients = (notableClients) => {
    const { isMobile } = getContext();

    return !isMobile && !!notableClients?.length;
};
